import React from "react";

const Button = (props) => {
  const { title, style, className, onClick, disabled, color, bgColor } = props;

  const handleClick = (e) => {
    // Prevent force click when button is disabled
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(e);
    }
  };

  return (
    <button
      className={` rounded-md px-6 py-1 text-bold  ${className} ${
        disabled
          ? "cursor-default bg-gray-400 text-gray-200 pointer-events-none"
          : `${color || "text-white"} ${bgColor || "bg-primary"}`
      }`}
      style={style}
      onClick={handleClick}
      disabled={disabled}
      onMouseDown={(e) => disabled && e.preventDefault()}
      onTouchStart={(e) => disabled && e.preventDefault()}
    >
      {title}
    </button>
  );
};

export default Button;
